export default "__VITE_ASSET__Dvcmo0NX__"